<div class="container">
  <h2>Your all-in-one tool chain to create, customize, and publish 2D maps.</h2>
  <p>Load your Roblox game, render with the RoRender plugin, and start editing on our bespoke map editor tool</p>
</div>
<div class="grid-container">
  <div class="grid">
    @for (element of gridElements; track element) {
    <div class="grid-element">
      <i [class]="'icon fi fi-rr-' + element.icon" [style.color]="element.color"></i>
      <h2 class="text">{{element.title}}</h2>
      <p class="text">{{element.description}}</p>
    </div>
    }
  </div>
</div>
